import axios from "axios";
import { AppConfig, AuthConfig } from "../handler/Configurations";

export class Request {
  constructor(headers) {
    headers = {
      ...headers,
      "Content-Type": "application/json",
    };
    this.instance = axios.create({
      headers: headers,
    });
  }

  async post(url, data, oncatch) {
    const greq = await this.instance.post(url, data).catch(oncatch);
    return greq;
  }

  async get(url, data = null, oncatch) {
    const greq = await this.instance
      .get(url, {
        params: {
          ...data,
        },
      })
      .catch(oncatch);
    return greq;
  }

  async delete(url, data = null, ondelete, oncatch) {
    const greq = await this.instance
      .delete(url, {
        params: {
          ...data,
        },
      })
      .catch(oncatch);
    ondelete(
      (greq && "status" in greq && greq.status && greq.status) || null,
      (greq && "data" in greq && greq.data && greq.data) || null,
      (greq && "headers" in greq && greq.headers && greq.headers) || null,
      (greq && "request" in greq && greq.request && greq.request) || null,
      (greq && "statusText" in greq && greq.statusText && greq.statusText) ||
        null,
      (greq && "config" in greq && greq.config && greq.config) || null,
      greq
    );
  }

  async patch(url, data = null, onpatch, oncatch) {
    const greq = await this.instance.patch(url, data).catch(oncatch);
    onpatch(
      (greq && "status" in greq && greq.status && greq.status) || null,
      (greq && "data" in greq && greq.data && greq.data) || null,
      (greq && "headers" in greq && greq.headers && greq.headers) || null,
      (greq && "request" in greq && greq.request && greq.request) || null,
      (greq && "statusText" in greq && greq.statusText && greq.statusText) ||
        null,
      (greq && "config" in greq && greq.config && greq.config) || null,
      greq
    );
  }
}
